import React, { useEffect, useState } from "react";
import "./BookInspectionForm.css";
import emailjs from "emailjs-com";
import { submitLeadToERP } from "../../../utils/leadSubmission";

const CITY_API_URL =
  "https://api.reportengine-prod.ezeetask.com/master-data/states";

/** Indian mobile: 10 digits starting with 6–9 */
const INDIAN_MOBILE_PATTERN = /^[6-9]\d{9}$/;

const normalizeIndianMobileDigits = (raw) => {
  let digits = String(raw).replace(/\D/g, "");
  if (digits.startsWith("91") && digits.length > 10) {
    digits = digits.slice(2);
  }
  digits = digits.slice(0, 10);
  if (digits.length > 0 && !/^[6-9]/.test(digits)) {
    digits = digits.replace(/^[^6-9]+/, "");
  }
  return digits;
};

const FALLBACK_CITY_OPTIONS = [
  { id: "delhi", name: "Delhi" },
  { id: "gurgaon", name: "Gurgaon" },
  { id: "noida", name: "Noida" },
  { id: "greater-noida", name: "Greater Noida" },
  { id: "ghaziabad", name: "Ghaziabad" },
  { id: "faridabad", name: "Faridabad" },
  { id: "Other", name: "Other" },
];

const parseStatesToCityOptions = (states) => {
  if (!Array.isArray(states)) return [];

  const options = [];
  states.forEach((state) => {
    if (!state?.isActive || !Array.isArray(state.cities)) return;

    state.cities.forEach((city) => {
      if (!city?.isActive || !city.id || !city.name) return;
      options.push({ id: city.id, name: city.name });
    });
  });

  const hasOther = options.some((city) => city.name === "Other");
  if (!hasOther) options.push({ id: "Other", name: "Other" });

  return options;
};

function BookInspectionForm() {
  const [messageSend, setMessageSend] = useState("");
  const [messageError, setMessageError] = useState("");
  const [isSending, setIsSending] = useState(false);

  const [emailData, setEmailData] = useState({
    name: "",
    address: "",
    city: "",
    otherCity: "",
    area: "",
    paymentType: "",
    phone: "",
    email: "",
    message: "",
  });

  const [cityOptions, setCityOptions] = useState(FALLBACK_CITY_OPTIONS);
  const [selectedItems, setSelectedItems] = useState([]);

  useEffect(() => {
    const fetchCities = async () => {
      try {
        const response = await fetch(CITY_API_URL);
        if (!response.ok) throw new Error(`City API returned ${response.status}`);

        const data = await response.json();
        const parsed = parseStatesToCityOptions(data);
        setCityOptions(parsed.length > 0 ? parsed : FALLBACK_CITY_OPTIONS);
      } catch (error) {
        console.warn("City API unavailable, using fallback list:", error);
        setCityOptions(FALLBACK_CITY_OPTIONS);
      }
    };

    fetchCities();
  }, []);

  const getSelectedCity = () =>
    cityOptions.find((city) => city.id === emailData.city);

  const getCityNameForSheet = () => {
    if (emailData.city === "Other") return emailData.otherCity.trim();
    return getSelectedCity()?.name || "";
  };

  const selectChangeHandler = (e) => {
    const itemName = e.target.name;
    if (e.target.checked) {
      setSelectedItems((prevItems) => [...prevItems, itemName]);
    } else {
      setSelectedItems((prevItems) =>
        prevItems.filter((item) => item !== itemName)
      );
    }
  };

  // useEffect(() => {
  //   setSelectedItems(selectedItems)
  // }, [selectedItems])
  // console.log(selectedItems.join(', '))

  // const bookingFormSubmit = (e) => {
  //   e.preventDefault();

  //   if (!validateEmail(emailData.email)) {
  //     setMessageError("Invalid email format");
  //     return;
  //   }
  //   emailData.selectedItems = selectedItems.join(', ');
  //   setIsSending(true);

  //   emailjs
  //     .send(
  //       "service_jf6shcl",
  //       "template_k2o4xw9",
  //       emailData,
  //       "template_5wisxmm"
  //     )
  //     .then(
  //       (response) => {
  //         setMessageSend("Email sent successfully");
  //         window.location.href = "/payment-methods";
  //       },
  //       (error) => {
  //         setMessageError("Email sending failed");
  //       }
  //     )

  //     .finally(() => {
  //       setIsSending(false);
  //     });
  // };

  // const handleSubmit = (e) => {
  //   e.preventDefault();

  //   if (!validateEmail(emailData.email)) {
  //     console.error("Invalid email format");
  //     return;
  //   }

  //   setIsSending(true);

  //   emailjs
  //     .send(
  //       "service_jf6shcl",
  //       "template_4lsqsm9",
  //       emailData,
  //       "mEkdQ2vp13ZtJ5Iib"
  //     )
  //     .then(
  //       (response) => {
  //         setMessageSend("Email sent successfully");
  //         // console.log("Email sent successfully", response);
  //         window.location.href = "/payment-methods";
  //       },
  //       (error) => {
  //         setMessageError("Email sending failed");
  //         // console.error("Email sending failed", error);
  //       }
  //     )

  //     .finally(() => {
  //       setIsSending(false); // Email sending completed, change button text back
  //     });
  // };

  const handleSubmit = async () => {
    const firstService = selectedItems.length > 0 ? selectedItems[0] : "NA";
    const otherServices = selectedItems.length > 1 ? selectedItems.slice(1).join(", ") : "";
    const result = await submitLeadToERP({
      name: emailData.name,
      phone: emailData.phone,
      cityId: emailData.city !== "Other" ? emailData.city : "",
      otherCity: emailData.city === "Other" ? emailData.otherCity.trim() : "",
      email: emailData.email || "",
      serviceType: firstService,
      otherServiceType: otherServices,
      additionalData: {
        formType: "BookInspection",
        origin: typeof window !== "undefined" ? window.location.href : "book-inspection",
        route: typeof window !== "undefined" ? window.location.pathname : "/book-inspection",
        cityName: getCityNameForSheet(),
        address: emailData.address,
        area: emailData.area,
        paymentType: emailData.paymentType,
        message: emailData.message,
        selectedItems: selectedItems.join(", "),
      },
    });
    if (result.erpSuccess || result.sheetsSuccess) {
      setEmailData({
        name: "",
        address: "",
        city: "",
        otherCity: "",
        area: "",
        paymentType: "",
        phone: "",
        email: "",
        message: "",
      });
      setSelectedItems([]);
    }
    return result;
  };

  const bookingFormSubmit = async (e) => {
    e.preventDefault();

    if (!validateEmail(emailData.email)) {
      setMessageError("Invalid email format");
      return;
    }

    if (!emailData.name || !emailData.phone || !emailData.address || !emailData.city) {
      setMessageError("Please fill in all required fields.");
      return;
    }

    if (!INDIAN_MOBILE_PATTERN.test(emailData.phone)) {
      setMessageError("Please enter a valid 10-digit mobile number.");
      return;
    }

    if (emailData.city === "Other" && !emailData.otherCity.trim()) {
      setMessageError("Please enter your city.");
      return;
    }

    const updatedEmailData = {
      ...emailData,
      city: getCityNameForSheet(),
      selectedItems: selectedItems.join(", "),
    };

    setIsSending(true);
    setMessageError("");
    setMessageSend("");

    const result = await handleSubmit();
    if (!result.erpSuccess && !result.sheetsSuccess) {
      setMessageError(result.message || "Lead could not be saved. Please try again.");
      setIsSending(false);
      return;
    }

    emailjs.init("mEkdQ2vp13ZtJ5Iib");
    emailjs
      .send("service_jf6shcl", "template_4lsqsm9", updatedEmailData)
      .then(
        () => {
          setMessageSend("Email sent successfully");
          window.location.href = "/payment-methods";
        },
        (error) => {
          setMessageError("Email sending failed. Please try again.");
          console.error("Email sending failed", error);
        }
      )
      .finally(() => {
        setIsSending(false);
      });
  };

  const validateEmail = (email) => {
    // Define a simple regex pattern for email validation
    const emailPattern = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;
    return emailPattern.test(email);
  };

  const bookingFormChange = (e) => {
    const { name, value } = e.target;
    setEmailData((prev) => ({
      ...prev,
      [name]: value,
      ...(name === "city" && value !== "Other" ? { otherCity: "" } : {}),
    }));
  };

  const phoneChangeHandler = (e) => {
    setEmailData((prev) => ({
      ...prev,
      phone: normalizeIndianMobileDigits(e.target.value),
    }));
  };

  return (
    <div className="booking_form">
      <h3 className="mb-3">Book Expert Visit</h3>
      <form onSubmit={bookingFormSubmit}>
        <div className="row">
          <div className="mb-3 col-lg-12">
            <label htmlFor="name" className="form-label">
              Name *
            </label>
            <input
              type="text"
              className="form-control"
              name="name"
              id="name"
              value={emailData.name}
              onChange={bookingFormChange}
              required
            />
          </div>
          <div className="mb-3 col-lg-12">
            <label htmlFor="address" className="form-label">
              Address *
            </label>
            <textarea
              className="form-control"
              id="address"
              name="address"
              rows="2"
              value={emailData.address}
              onChange={bookingFormChange}
              required
            ></textarea>
          </div>
          <div className="mb-3 col-lg-6">
            <label htmlFor="city" className="form-label">
              City *
            </label>
            <select
              className="form-select"
              id="city"
              name="city"
              value={emailData.city}
              onChange={bookingFormChange}
              required
            >
              <option value="" disabled>
                Select City
              </option>
              {cityOptions.map((city) => (
                <option key={city.id} value={city.id}>
                  {city.name}
                </option>
              ))}
            </select>
          </div>
          {emailData.city === "Other" && (
            <div className="mb-3 col-lg-6">
              <label htmlFor="otherCity" className="form-label">
                Enter your city *
              </label>
              <input
                type="text"
                className="form-control"
                id="otherCity"
                name="otherCity"
                value={emailData.otherCity}
                onChange={bookingFormChange}
                required
              />
            </div>
          )}
          <div className="mb-3 col-lg-6">
            <label htmlFor="area" className="form-label">
              Area (sq.ft) *
            </label>
            <input
              type="text"
              className="form-control"
              id="area"
              value={emailData.area}
              onChange={bookingFormChange}
              name="area"
              required
            />
          </div>
          <div className="mb-3">
            <label htmlFor="paymentType" className="form-label">
              Property Type *
            </label>
            <select
              className="form-select"
              aria-label="Default select example"
              id="paymentType"
              name="paymentType"
              value={emailData.paymentType}
              onChange={bookingFormChange}
            >
              <option value="" disabled>
                Select Type
              </option>
              <option value="Residential / Bungalow / Apartment">
                Residential / Bungalow / Apartment
              </option>
              <option value="School / Hospital / Hotels">
                School / Hospital / Hotels
              </option>
              <option value="pre-visit-payment">Commercial</option>
              <option value="pre-visit-payment">Other</option>
            </select>
          </div>
          <div className="mb-3 col-lg-6">
            <label htmlFor="phone" className="form-label">
              Phone *
            </label>
            <div className="input-group">
              <span className="input-group-text">+91</span>
              <input
                type="tel"
                className="form-control"
                id="phone"
                name="phone"
                value={emailData.phone}
                onChange={phoneChangeHandler}
                inputMode="numeric"
                maxLength={10}
                pattern="[6-9][0-9]{9}"
                placeholder=""
                title="Enter a 10-digit mobile number"
                required
              />
            </div>
          </div>
          <div className="mb-3 col-lg-6">
            <label htmlFor="email" className="form-label">
              Email *
            </label>
            <input
              type="email"
              className="form-control"
              id="email"
              name="email"
              value={emailData.email}
              onChange={bookingFormChange}
              required
            />
          </div>
          <div className="mb-3">
            <label htmlFor="message" className="form-label">
              Let us know what you need help with...
            </label>
            <textarea
              className="form-control"
              id="message"
              name="message"
              value={emailData.message}
              onChange={bookingFormChange}
              rows="3"
            ></textarea>
          </div>

          <div className="mb-3">
            <label htmlFor="service" className="form-label">
              Choose your Service
            </label>
            <div className="form-check">
              <input
                className="form-check-input"
                type="checkbox"
                id="seepageCheckbox"
                name="Seepage Leakage Detection"
                onChange={selectChangeHandler}
              />
              <label className="form-check-label" htmlFor="seepageCheckbox">
                Seepage/Leakage Detection
              </label>
            </div>
            <div className="form-check">
              <input
                className="form-check-input"
                type="checkbox"
                id="electricalCheckbox"
                name="Electrical Inspection"
                onChange={selectChangeHandler}
              />
              <label className="form-check-label" htmlFor="electricalCheckbox">
                Electrical Inspection
              </label>
            </div>
            <div className="form-check">
              <input
                className="form-check-input"
                type="checkbox"
                id="documentCheckbox"
                name="Document Verification"
                onChange={selectChangeHandler}
              />
              <label className="form-check-label" htmlFor="documentCheckbox">
                Document Verification
              </label>
            </div>
            <div className="form-check">
              <input
                className="form-check-input"
                type="checkbox"
                id="pmcCheckbox"
                name="PMC Consultation"
                onChange={selectChangeHandler}
              />
              <label className="form-check-label" htmlFor="pmcCheckbox">
                PMC Consultation
              </label>
            </div>
            <div className="form-check">
              <input
                className="form-check-input"
                type="checkbox"
                id="vastuCheckbox"
                name="Vastu"
                onChange={selectChangeHandler}
              />
              <label className="form-check-label" htmlFor="vastuCheckbox">
                Vastu
              </label>
            </div>
          </div>
          <button type="submit" className="btn site_btn" disabled={isSending}>
            {isSending ? "Sending..." : "Submit"}
          </button>
          <p className="formmessage">
            {messageSend} {messageError}
          </p>
        </div>
      </form>
    </div>
  );
}

export default BookInspectionForm;
